import React, { useState } from 'react';
import './ContactForm.css';
import contacts, {FormData} from "../../api/contacts";

export default () => {
    const [formData, setFormData] = useState<FormData>({
        name: '',
        email: '',
        company: '',
        idea: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await contacts(formData);
        console.log('Форма отправлена:', formData);
    };

    return (
        <div className="container">
            <p>Поделитесь своими идеями для сотрудничества.</p>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Ваше имя</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="input-field"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">Адрес электронной почты</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="input-field"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="company">Название компании</label>
                    <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        className="input-field"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="idea">Идея для сотрудничества</label>
                    <textarea
                        id="idea"
                        name="idea"
                        value={formData.idea}
                        onChange={handleChange}
                        required
                        className="textarea-field"
                    />
                </div>

                <button type="submit" className="submit-button">
                    Отправить
                </button>
            </form>
        </div>
    );
};
